import React from 'react';
import { Modal, Pressable, StyleSheet, Text, View } from 'react-native';
import { GEAR_META, Gear, TOOL_NAMES } from '../domain/olmps';
import { makeThemedStyles, DISPLAY_FONT, radii } from '../v10/theme';
import { GlassFill } from './glass';

export function InfoPopup({
  open,
  onClose,
  gear,
  toolId,
  onOpenChat,
}: {
  open: boolean;
  onClose: () => void;
  gear: Gear;
  toolId: string | null;
  onOpenChat: () => void;
}) {
  const styles = useStyles();
  const meta = GEAR_META[gear];
  return (
    <Modal visible={open} transparent animationType="fade" onRequestClose={onClose}>
      <Pressable style={styles.backdrop} onPress={onClose}>
        <Pressable style={styles.card} onPress={() => {}}>
          <GlassFill strong radius={radii.panel} />
          <Pressable onPress={onClose} style={styles.close} hitSlop={10} accessibilityLabel="Close">
            <Text style={styles.closeText}>✕</Text>
          </Pressable>
          <Text style={styles.title}>{toolId ? TOOL_NAMES[toolId] ?? toolId : 'OLMPS'}</Text>
          <Text style={styles.context}>
            {meta.name} — “{meta.question}”
          </Text>
          <Pressable style={styles.syqiButton} onPress={onOpenChat}>
            <Text style={styles.syqiText}>SyQi</Text>
          </Pressable>
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const useStyles = makeThemedStyles(({ t, c, neu }) =>
  StyleSheet.create({
    backdrop: {
      flex: 1,
      backgroundColor: c.overlay,
      alignItems: 'center',
      justifyContent: 'center',
      padding: 32,
    },
    card: {
      width: '100%',
      maxWidth: 340,
      backgroundColor: 'transparent',
      overflow: 'hidden',
      borderWidth: 1,
      borderColor: t.navyLine,
      borderRadius: radii.panel,
      padding: 24,
      alignItems: 'center',
      ...neu.raisedLg,
    },
    close: {
      position: 'absolute',
      top: 10,
      right: 10,
      width: 28,
      height: 28,
      borderRadius: 14,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: t.glass,
      zIndex: 2,
    },
    closeText: { fontSize: 12, fontWeight: '900', color: t.ivorySoft },
    title: { fontSize: 20, fontWeight: '900', color: t.ivory, letterSpacing: 2.5, fontFamily: DISPLAY_FONT, textTransform: 'uppercase' },
    context: {
      marginTop: 8,
      marginBottom: 20,
      color: t.ivorySoft,
      textAlign: 'center',
      fontSize: 14,
    },
    syqiButton: {
      backgroundColor: t.gold,
      boxShadow: `0 0 16px ${t.goldGlow}`,
      borderRadius: radii.pill,
      paddingHorizontal: 36,
      paddingVertical: 12,
    },
    syqiText: { fontWeight: '900', fontSize: 16, color: t.onGold, letterSpacing: 1 },
  }),
);
